<script lang="ts">
	//UI
	//Utils
	//Types
	//Props
	export let active = false;
	export let deActiveFill = "#6d6f76";
	export let activeFill = "#e6e7ed";
	//Constants
	//Variables
	//Functions
	//Do

</script>

<svg
	xmlns="http://www.w3.org/2000/svg"
	width="31.487"
	height="30.057"
	viewBox="0 0 31.487 30.057">
	<g>
		<g>
			<path
				d="M425.156 234.545a.6.6 0 0 1-.605-.606v-10.1c0-7.83-3.929-11.969-11.363-11.97s-11.366 4.141-11.366 11.97v10.1a.606.606 0 1 1-1.211 0v-10.1c0-8.5 4.466-13.18 12.574-13.182s12.577 4.682 12.577 13.182v10.1a.605.605 0 0 1-.606.606z"
				transform="translate(-397.443 -210.66)"
				style={`fill:${active ? activeFill : deActiveFill}`} />
		</g>
		<g>
			<path
				d="M423.742 249.106a6.781 6.781 0 0 1-13.562 0z"
				transform="translate(-401.218 -225.827)"
				style={`fill:${active ? activeFill : deActiveFill}`} />
		</g>
		<g>
			<path
				d="M426.26 249.317h-30.275a.606.606 0 1 1 0-1.211h30.275a.606.606 0 0 1 0 1.211z"
				transform="translate(-395.379 -225.432)"
				style={`fill:${active ? activeFill : deActiveFill}`} />
		</g>
	</g>
</svg>

<style lang="scss">
	svg {
		&:hover {
			cursor: pointer;
			path {
				fill: #bcbfc3 !important;
			}
		}
	}
</style>
